<template>
    <div class="main-container">
        <!-- Author: Vaishnavi
      Date: 12/12/2019
      Issue Description: Breadcrumb alignment -->
        <breadcrumb :list="breadcrumbList" />
      <tl-tabs :tabs="tabs" class="space">
          <tl-tab>
              <assign-perk/>
          </tl-tab>
          <tl-tab>
              <employee-log/>
          </tl-tab>
      </tl-tabs>
    </div>
</template>

<script>
import AssignPerk from './assignperk.vue'
import EmployeeLog from './employeelog.vue'
export default {
  components:{
    AssignPerk,EmployeeLog
  },  
  data(){
    return{
      breadcrumbList:[
              {
                name: "Organisation",
                url: `/dashboard/${this.$route.params.entity_index}/organisation`
              },
              {
                name: "Utilities",
                url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities`
              },
              {
                name: "Assign Perk",
                url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/assignperk`
              }
        ],
      tabs: [{
          header: 'Manage Perks'
        },
        {
          header: 'Employee Log'
        }
      ]
    }
  },  
  methods:{
    routeToMainStep(){this.$router.push({path:`/dashboard/${this.$route.params.entity_index}/organisation/`})},
    routeToSubStep(){this.$router.push({path:`/dashboard/${this.$route.params.entity_index}/organisation/utilities`})}
  }
}
</script>

<style scoped style="scss">
.space{
  padding-top: 30px;
}
</style>
